import { Component, OnInit } from '@angular/core';
import { getPiiServiceId } from '../../../../shared/pii/pii.utils';
import { GetProductDetails } from '../../../../store/actions/product-details.actions';
import {
  ApplicationState,
  getProductDetailsTechnicalError,
  getSelectedProductDetails,
} from '../../../../store/reducers';
import { OnDestroyHookDirective } from '../../../../shared/hooks';
import { ActivatedRoute } from '@angular/router';
import { Store } from '@ngrx/store';
import { TranslationService } from '@proximus/ng-common';
import {
  LevelType,
  MessageType,
  PxModalMessageService,
} from '@proximus/ng-common-components';

@Component({
  selector: 'mprd-mobile-settings-pxsplus',
  templateUrl: './mobile-settings-pxsplus.component.html',
})
export class MobileSettingsPxsplusComponent
  extends OnDestroyHookDirective
  implements OnInit
{
  selectedProduct: any;
  hasError = false;
  constructor(
    private route: ActivatedRoute,
    private store: Store<ApplicationState>,
    private translationService: TranslationService,
    private pxModalMessageService: PxModalMessageService,
  ) {
    super();
  }

  ngOnInit(): void {
    const serviceId = getPiiServiceId();
    if (serviceId) {
      this.addSubscription(
        this.route.params.subscribe((params) => {
          this.store.dispatch(
            new GetProductDetails({
              productType: 'mobile',
              serviceId,
            }),
          );
        }),
      );

      this.addSubscription(
        this.store.select(getSelectedProductDetails).subscribe((value) => {
          if (value && value.mobileProductDetails) {
            this.selectedProduct = value.mobileProductDetails;
          }
        }),
      );

      this.addSubscription(
        this.store
          .select(getProductDetailsTechnicalError)
          .subscribe((value) => {
            this.hasError = value !== undefined;

            if (!this.selectedProduct && this.hasError) {
              this.displayErrorMessage();
            }
          }),
      );
    } else {
      this.hasError = true;
      this.displayErrorMessage();
    }
  }

  private displayErrorMessage() {
    this.pxModalMessageService.dispatchMessage(
      MessageType.Error,
      LevelType.Root,
      this.translationService.getTranslatedValueFor(
        'mobile.settings.pxsplus.error.message',
      ),
      this.translationService.getTranslatedValueFor('message.error.title'),
      false,
      false,
      'backendError',
    );
  }
}
